import { competitionsAtom } from '@/atoms/queries/competitions';
import { createOptionsAtom } from '@/utils/atoms/generic';

export const eventDataCompetitionsOptionsAtom = createOptionsAtom(competitionsAtom, 'name', 'competition_id', [
  'area_code',
]);
